import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const Variants = cva('bg-foreground h-full rounded-md', {
  variants: {
    score: {
      0: 'w-0',
      1: 'w-1/5',
      2: 'w-2/5',
      3: 'w-3/5',
      4: 'w-4/5',
      5: 'w-full',
    },
  },
  defaultVariants: {
    score: 5,
  },
});

export interface ReviewBarProps {
  title?: string | undefined;
  score?: 0 | 1 | 2 | 3 | 4 | 5;
}
function ReviewBar({ title = '', score = 0, ...props }: ReviewBarProps) {
  return (
    <div className="text-b4">
      <p>{title}</p>
      <div className="center-wrapper flex gap-4">
        <div className="bg-muted h-2 w-full overflow-clip rounded-md">
          <div className={cn(Variants({ score }))} {...props}></div>
        </div>
        <p>{score}</p>
      </div>
    </div>
  );
}

export { ReviewBar, Variants };
